import styles from "./Locais.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Button from "../../../../components/components-ui/Button/Button";
import Loading from "../../../../components/components-ui/Loading/Loading";
import { Table } from "../../../../components/Table";
import { Grid, Col } from "../../../../components/Grid";
import { InfoSeachContext } from "../../../../Provider/InfoSearch";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import InputClear from "../../../../components/components-ui/InputClear/InputClear";
import { AuthContext } from "../../../../Provider/AuthContext";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";
import { useOrdenacao } from "../../../../utils/useOrdenacao";

const columns = [
  {
    column: "Cód. Local",
    key: "id_local",
  },
  {
    column: "Nome Local/Marca",
    key: "nome_local",
  },
  {
    column: "Freguesia",
    key: "Freguesia",
  },
  {
    column: "Dia",
    key: "diaDaSemana",
  },
  {
    column: "Periodicidade",
    key: "periodicidade",
  },
  {
    column: "Bairro",
    key: "bairro",
  },
  {
    column: "CNPJ",
    key: "CNPJ",
  },
  {
    column: "Grupo",
    key: "grupo",
  },
  {
    column: "Status",
    key: "status",
  },
];

export default function Local() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();
  const [showLoading, setShowLoading] = useState(false);
  const [status, setStatus] = useState([]);
  const [grupo, setGrupo] = useState([]);
  const [estabelecimento, setEstabelecimento] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const {
    setDataLocalSearch,
    dataLocalSearch,
    locais,
    setLocais,
    filterLocais,
    setFilterLocais,
  } = useContext(InfoSeachContext);

  const { dados, ordenar, ordem, setDados } = useOrdenacao(locais, setLocais);

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela locais
    verificaPermissao(idTipoUsuario, 39);
  }, []);

  useEffect(() => {
    async function getLocal() {
      setShowLoading(true);
      // setListaLocal([]);
      let response = "";
      if (filterLocais) {
        response = await api.get(
          `/local/index?page=${currentPage}${filterLocais}`
        );
      } else {
        response = await api.get(
          `/local/index?page=${currentPage}&id_status=3`
        );
      }
      setTotalPages(response.data.totalPages);
      // setListaLocal(response.data.data);
      setLocais(response.data.data);
      setCurrentPage(response.data.currentPageNumber);
      setShowLoading(false);
    }
    getLocal();
  }, [currentPage, filterLocais]);

  function filterList(values) {
    let data = `${
      values?.codigoPonto ? `&id_local=${values?.codigoPonto}` : ""
    }`;
    data =
      data +
      `${values?.razaoSocial ? `&nome_local=${values?.razaoSocial}` : ""}`;
    data = data + `${values?.status ? `&id_status=${values?.status}` : ""}`;
    data = data + `${values?.grupo ? `&id_grupo=${values?.grupo}` : ""}`;
    data =
      data +
      `${
        values?.estabelecimento
          ? `&id_estabelecimento=${values?.estabelecimento}`
          : ""
      }`;
    data += `${values?.endereco ? `&endereco=${values?.endereco}` : ""}`;
    data += `${values?.bairro ? `&bairro=${values?.bairro}` : ""}`;
    data += `${values?.freguesia ? `&freguesia=${values?.freguesia}` : ""}`;
    data += `${values?.cnpj ? `&cnpj=${values?.cnpj}` : ""}`;

    setCurrentPage(1);
    setFilterLocais(data);

    setDataLocalSearch({
      codigoPonto: values?.codigoPonto,
      razaoSocial: values?.razaoSocial,
      numeroColeta: values?.numeroColeta,
      status: values?.status,
      grupo: values?.grupo,
      estabelecimento: values?.estabelecimento,
      freguesia: values?.freguesia,
      razaoSocial: values?.razaoSocial,
      endereco: values?.endereco,
      bairro: values?.bairro,
      cnpj: values?.cnpj,
    });
  }

  useEffect(() => {
    // Carrega Status
    async function getStatus() {
      const response = await api.get(`/local/status/index`);
      setStatus(response.data);
    }
    getStatus();
    // Carrega Grupo
    async function getGrupo() {
      const response = await api.get(`/grupo/index`);
      setGrupo(response.data);
    }
    getGrupo();
    // Carregar Estabelecimento
    async function getEstabelecimento() {
      const response = await api.get(`/estabelecimento/index?`);
      setEstabelecimento(response.data);
    }
    getEstabelecimento();
  }, []);

  //Função para scrollar até o topo da tabela ao mudar de página
  function scrollToTop() {
    const tabela_locais = document.getElementById("tabela_locais");
    tabela_locais.scrollIntoView({ behavior: "instant" });
  }

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
    scrollToTop();
  }

  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
    scrollToTop();
  }

  function resetFilters(resetForm, setFieldValue) {
    resetForm();
    setDataLocalSearch("");
    setFieldValue("codigoPonto", "");
    setFieldValue("razaoSocial", "");
    setFieldValue("estabelecimento", "");
    setFieldValue("status", 3);
    setFieldValue("grupo", "");
    setFieldValue("freguesia", "");
    setFieldValue("endereco", "");
    setFieldValue("bairro", "");
    setFieldValue("cnpj", "");
    setFilterLocais("");
    setCurrentPage(1);
  }

  const ValidationSchema = Yup.object().shape({
    codigoPonto: Yup.number(),
    razaoSocial: Yup.string(),
    estabelecimento: Yup.string(),
    status: Yup.string(),
    grupo: Yup.string(),
  });

  return (
    <Container>
      <h3>Locais</h3>

      <div className={styles.content}>
        <Link to="/usina/action-painel/" style={{ display: "contents" }}>
          <Button title="Novo" type="button" />
        </Link>
        <Formik
          initialValues={{
            codigoPonto: dataLocalSearch?.codigoPonto
              ? dataLocalSearch?.codigoPonto
              : "",
            razaoSocial: dataLocalSearch?.razaoSocial
              ? dataLocalSearch?.razaoSocial
              : "",
            estabelecimento: dataLocalSearch?.estabelecimento
              ? dataLocalSearch?.estabelecimento
              : "",
            status: dataLocalSearch?.status ? dataLocalSearch?.status : 3,
            grupo: dataLocalSearch?.grupo ? dataLocalSearch?.grupo : "",
            freguesia: dataLocalSearch?.freguesia
              ? dataLocalSearch?.freguesia
              : "",
            endereco: dataLocalSearch?.endereco
              ? dataLocalSearch?.endereco
              : "",
            bairro: dataLocalSearch?.bairro ? dataLocalSearch?.bairro : "",
            cnpj: dataLocalSearch?.cnpj ? dataLocalSearch?.cnpj : "",
          }}
          validationSchema={ValidationSchema}
          onSubmit={(values) => filterList(values)}
        >
          {({ errors, touched, resetForm, setFieldValue, values }) => (
            <Form>
              <section className={styles.wrap}>
                <div className={styles.filter_header}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      title="Limpar filtros"
                      type="button"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={1}>
                    <label>Cód. Ponto</label>
                    <Field type="number" name="codigoPonto">
                      {({ field }) => (
                        <InputClear
                          type="number"
                          onClick={() => setFieldValue("codigoPonto", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.codigoPonto && touched.codigoPonto ? (
                      <span className={styles.alertError}>
                        {errors.codigoPonto}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={2}>
                    <label>Local / Marca</label>
                    <Field
                      type="text"
                      name="razaoSocial"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("razaoSocial", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.razaoSocial && touched.razaoSocial ? (
                      <span className={styles.alertError}>
                        {errors.razaoSocial}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={1}>
                    <label>Freguesia</label>
                    <Field
                      type="text"
                      name="freguesia"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("freguesia", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.freguesia && touched.freguesia ? (
                      <span className={styles.alertError}>
                        {errors.freguesia}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Status</label>
                    <Field
                      name="status"
                      component={SelectSearch}
                      options={status.map((values) => ({
                        value: values?.idstatus,
                        label: values?.Status,
                      }))}
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Endereço</label>
                    <Field
                      type="text"
                      name="endereco"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("endereco", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.endereco && touched.endereco ? (
                      <span className={styles.alertError}>
                        {errors.endereco}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Bairro</label>
                    <Field
                      type="text"
                      name="bairro"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("bairro", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.bairro && touched.bairro ? (
                      <span className={styles.alertError}>{errors.bairro}</span>
                    ) : null}
                  </Col>

                  {/* <Col size={2}>
                    <label>Estabelecimento</label>
                    <Field component="select" name="estabelecimento">
                      <option value="">Selecione</option>
                      {estabelecimento.map((values) => (
                        <option
                          key={values?.id_estabelecimento}
                          value={values?.id_estabelecimento}
                        >
                          {values?.estabelecimento}
                        </option>
                      ))}
                    </Field>
                    {errors.estabelecimento && touched.estabelecimento ? (
                      <span className={styles.alertError}>
                        {errors.estabelecimento}
                      </span>
                    ) : null}
                  </Col> */}

                  <Col size={2}>
                    <label>CNPJ</label>
                    <Field
                      type="text"
                      name="cnpj"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("cnpj", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.cnpj && touched.cnpj ? (
                      <span className={styles.alertError}>{errors.cnpj}</span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Grupo</label>
                    <Field
                      name="grupo"
                      component={SelectSearch}
                      options={grupo.map((values) => ({
                        label: values?.descricao_grupo,
                        value: values?.id_grupo,
                      }))}
                    />
                    {errors.grupo && touched.grupo ? (
                      <span className={styles.alertError}>{errors.grupo}</span>
                    ) : null}
                  </Col>
                </Grid>
              </section>
            </Form>
          )}
        </Formik>
        {/*  */}

        <Table
          edit
          columns={columns}
          onSort={ordenar}
          ordem={ordem}
          id="tabela_locais"
        >
          {!showLoading &&
            dados.map((values) => (
              <tr key={values?.id_local}>
                <td>
                  <Link to={`/usina/action-painel/edit/${values?.id_local}`}>
                    <i className="fas fa-pencil-alt"></i>
                  </Link>
                </td>
                <td>{values?.id_local}</td>
                <td style={{ textAlign: "left" }}>{values?.nome_local}</td>
                <td style={{ textAlign: "left" }}>{values?.Freguesia}</td>
                <td style={{ textAlign: "left" }}>{values?.diaDaSemana}</td>
                <td style={{ textAlign: "left" }}>{values?.periodicidade}</td>
                <td style={{ textAlign: "left" }}>{values?.bairro}</td>
                <td style={{ textAlign: "left" }}>{values?.CNPJ}</td>
                <td style={{ textAlign: "left" }}>{values?.grupo}</td>
                <td style={{ textAlign: "left" }}>{values?.status}</td>
              </tr>
            ))}
        </Table>
        {locais.length == 0 && !showLoading ? (
          <p style={{ textAlign: "center", marginBottom: "20px" }}>
            Nenhuma opção encontrada
          </p>
        ) : (
          ""
        )}
        <div className={styles.loading}>
          <Loading display={showLoading ? "block" : "none"} />
        </div>
        <div className={styles.table_pagination}>
          <div className={styles.table_pagination_buttons}>
            <Button
              disabled={currentPage === 1 ? true : false}
              onClick={() => previewPage()}
            >
              <i style={{ marginRight: 5 }} className="fas fa-chevron-left"></i>
              Voltar
            </Button>
            <span>
              {currentPage} De {totalPages}
            </span>
            <Button
              disabled={
                currentPage === totalPages || totalPages === 0 ? true : false
              }
              onClick={() => nextPage()}
            >
              Próxima
              <i style={{ marginLeft: 5 }} className="fas fa-chevron-right"></i>
            </Button>
          </div>
        </div>
      </div>
      {/*  */}
    </Container>
  );
}
